import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

export default function InfoModal({ open, onClose }) {
  const [html, setHtml] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    setError('');
    fetch('/help.html', { cache: 'no-cache' })
      .then(async (res) => {
        if (!res.ok) throw new Error(`Failed to load documentation: ${res.status}`);
        const text = await res.text();
        setHtml(text);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      {/* Modal */}
      <div className="relative z-10 w-[min(900px,95vw)] max-h-[90vh] rounded-lg bg-white shadow-xl border border-slate-200 overflow-hidden flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 bg-slate-50">
          <h2 className="text-sm font-semibold text-slate-700">How to use this app</h2>
          <button
            aria-label="Close"
            onClick={onClose}
            className="p-2 rounded-md hover:bg-slate-200/60 text-slate-600"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 overflow-auto p-4 prose prose-slate max-w-none">
          {loading && <p className="text-sm text-slate-500">Loading…</p>}
          {error && (
            <p className="text-sm text-red-600">{error}</p>
          )}
          {!loading && !error && (
            <div dangerouslySetInnerHTML={{ __html: html }} />
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
